module.exports = __webpack_public_path__ + "img/44_16.3a303cad.png";